<template>
  <v-combobox
    v-model="payload"
    :items="daysOptions"
    :search-input.sync="search"
    :hide-no-data="!search"
    v-bind="$attrs"
    :rules="[onlyNumbers]"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            Dia não criado
            "<strong>{{ search }}</strong>".
            Aperte <kbd>Enter</kbd> para criar
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'MessageDaysCombox',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    search: '',
    daysOptions: [],
  }),
  computed: {
    payload: {
      get() {
        this.insertIfNotHas();
        return this.value;
      },
      set(value) {
        this.$emit('updated', value);
      },
    },
    onlyNumbers() {
      return (v) => {
        if (Array.isArray(v)) {
          let rule = !!v;
          v.forEach((item) => {
            /* eslint no-restricted-globals: ["error", "event"] */
            if (isNaN(item)) {
              rule = 'Digite apenas números';
            }
          });

          return rule;
        }

        return !!v;
      };
    },
  },
  created() {
    this.setDefaultDays();
  },
  methods: {
    setDefaultDays() {
      this.daysOptions = [1, 2, 3, 4, 5];
    },
    insertIfNotHas() {
      const days = [];
      this.value.forEach((item) => {
        if (!this.daysOptions.find(day => day === item)) {
          days.push(item);
        }
      });
      days.forEach(item => this.daysOptions.push(item));
    },
  },
};
</script>

<style>

</style>
